import React, { useState, useEffect } from 'react';
import { ExternalLink, Sparkles } from 'lucide-react';

const LandingPage = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isLoaded, setIsLoaded] = useState(false);

  const INVITE_LINK = "https://discord.gg/uT6DBENfj3";
  const LOGO_URL = "https://customer-assets.emergentagent.com/job_discord-invite-1/artifacts/nxpjvmpl_logo.png";

  useEffect(() => {
    setIsLoaded(true);
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 30;
      const y = (e.clientY / window.innerHeight - 0.5) * 30;
      setMousePosition({ x, y });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleJoin = () => {
    window.open(INVITE_LINK, '_blank');
  };

  return (
    <div className="landing-container">
      {/* Animated Gradient Background */}
      <div className="background-layer">
        <div className="gradient-orb orb-1" />
        <div className="gradient-orb orb-2" />
        <div className="gradient-orb orb-3" />
        <div className="grid-overlay" />
        <div className="noise-overlay" />
      </div>

      {/* Floating Particles */}
      <div className="particles">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${8 + Math.random() * 12}s`,
              width: `${2 + Math.random() * 4}px`,
              height: `${2 + Math.random() * 4}px`,
            }}
          />
        ))}
      </div>

      {/* Main Content */}
      <main className="main-content">
        <div 
          className={`content-wrapper ${isLoaded ? 'loaded' : ''}`}
          style={{
            transform: `translate(${mousePosition.x * 0.3}px, ${mousePosition.y * 0.3}px)`
          }}
        >
          {/* Logo */}
          <div className="logo-container">
            <div className="logo-glow" />
            <img src={LOGO_URL} alt="Hector Logo" className="logo-image" />
          </div>

          {/* Server Badge */}
          <div className="badge">
            <Sparkles className="badge-icon" />
            <span>Discord Community</span>
          </div>

          {/* Main Title */}
          <h1 className="title">
            <span className="title-welcome">Join my discord server:</span>
            <span className="title-name">Hector</span>
          </h1>

          {/* Tagline */}
          <p className="tagline">
            Where friendships form, and memories are made.
          </p>

          {/* CTA Button */}
          <button onClick={handleJoin} className="join-button">
            <span className="button-bg" />
            <span className="button-content">
              <span>Join my server</span>
              <ExternalLink className="button-icon" />
            </span>
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <span>© 2025 Hector Community</span>
      </footer>
    </div>
  );
};

export default LandingPage;
